import React from 'react'
import { TableHeaderRow, TableCell } from '@sainsburys-tech/luna-table'

const TypographyTableHeader = () => (
  <TableHeaderRow>
    <TableCell>Name</TableCell>
    <TableCell>Style</TableCell>
    <TableCell>Font size</TableCell>
    <TableCell>Line height</TableCell>
    <TableCell>Responsive alternative for screens larger than 720px</TableCell>
  </TableHeaderRow>
)

export default TypographyTableHeader
